// @ts-check
// Traduce un fallo al cargar el enunciado de un ejercicio al texto que lee el
// alumno. Compartido por las tres páginas de editor.
//
// ## Por qué existe
//
// La cadena `error instanceof ApiError && error.kind === '...'` estaba escrita
// tres veces (`diagram-editor-page.js#mensajeDeErrorEjercicio`,
// `pseudocode-editor-page.js#mensajeDeErrorEjercicioSeleccionado`,
// `python-editor-page.js#mensajeDeErrorEjercicio`) y las tres solo se
// diferenciaban en el TEXTO, nunca en la lógica. Los textos sí se conservan
// distintos: cada editor dice algo distinto sobre qué sigue funcionando
// ("el editor sigue disponible sin enunciado" solo tiene sentido en
// diagramas), y unificarlos habría cambiado lo que ve el alumno.
//
// ## Por qué vive en `pages/` y no en el componente
//
// Clasificar el error obliga a conocer `services/api-errors.js`, y
// docs/03-frontend.md §4.2 prohíbe `components -> services`. `pages` sí puede
// (mismo criterio que `pages/nav-session.js`, que orquesta sesión para la
// barra mientras `components/session-menu.js` se queda puro).
//
// Ninguna de las variantes expone NUNCA el mensaje técnico crudo del backend
// (03-frontend §8.4/§9.1): un `kind` que no esté contemplado cae en el texto
// genérico.
import { ApiError } from '../services/api-errors.js';

/**
 * Textos de una página para cada situación. Solo `generico` es obligatorio:
 * una situación sin texto propio NO es un hueco, cae en el genérico. Así cada
 * página declara únicamente los casos que de verdad quiere distinguir, que es
 * en lo que ya diferían entre sí (diagramas distingue el fallo de red; las
 * otras dos, la sesión expirada).
 * @typedef {{
 *   noEncontrado?: string,
 *   sesionExpirada?: string,
 *   sinConexion?: string,
 *   generico: string,
 * }} TextosDeErrorEnunciado
 */

/**
 * @param {unknown} error error tal cual lo rechazó el cliente de API
 * @param {TextosDeErrorEnunciado} textos
 * @returns {string} mensaje listo para pintar, nunca el error técnico
 */
export function mensajeDeErrorEnunciado(error, textos) {
  if (error instanceof ApiError) {
    if (error.kind === 'not_found' && textos.noEncontrado) return textos.noEncontrado;
    if (error.kind === 'unauthorized' && textos.sesionExpirada) return textos.sesionExpirada;
    if (
      (error.kind === 'timeout' || error.kind === 'network_error') &&
      textos.sinConexion
    ) {
      return textos.sinConexion;
    }
  }
  return textos.generico;
}
